//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FEATURE_GUIDES from '@/utils/featureGuide'

export default {
  name: 'FeatureGuidePanel',
  props: {
    keys: {
      type: Array,
      default: () => null
    }
  },
  data () {
    return { expanded: false }
  },
  computed: {
    guides () {
      if (!this.keys || !this.keys.length) return FEATURE_GUIDES
      return FEATURE_GUIDES.filter(g => this.keys.includes(g.key))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/new/FeatureGuidePanel.vue